/**
 * Auth storage abstraction (T2.6).
 *
 * Backed by `localStorage`. The interface stays async so call sites
 * (`auth.ts`, supabase client) are oblivious to the backing store — a future
 * Secure Cookie wrapper can slot in without touching them. The Tauri-backed
 * variant was removed with the Tauri shell (判定ボード D-1, 2026-07-05); on
 * the web build it always delegated to `localStorage` anyway.
 */
export interface AuthStorage {
  get(key: string): Promise<string | null>;
  set(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
}

const webStorage: AuthStorage = {
  async get(key) {
    return globalThis.localStorage?.getItem(key) ?? null;
  },
  async set(key, value) {
    globalThis.localStorage?.setItem(key, value);
  },
  async remove(key) {
    globalThis.localStorage?.removeItem(key);
  },
};

export function getAuthStorage(): AuthStorage {
  return webStorage;
}
